
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dao",
      function () {
        return require("private-next-pages/dao/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dao"])
      });
    }
  